/**
 * The text conversation behind an open Mission evolution.
 *
 * aris-ai keys the stored chat thread by `session_id` and no endpoint hands it
 * back, so the client remembers it per `evolution_session_id`. Opening Text
 * again for the same evolution continues that thread; without it a fresh
 * thread starts (the server still resumes the evolution itself — Aris
 * welcomes the member back — but the earlier messages aren't on screen).
 * Every access is guarded: storage can be unavailable.
 */

const key = (evolutionSessionId) => `mission_evolution_chat:${evolutionSessionId}`;

export const rememberEvolutionChat = (evolutionSessionId, sessionId) => {
  if (!evolutionSessionId || !sessionId) return;
  try {
    localStorage.setItem(key(evolutionSessionId), sessionId);
  } catch (_) {
    /* storage unavailable: the next visit starts a fresh thread */
  }
};

export const recallEvolutionChat = (evolutionSessionId) => {
  if (!evolutionSessionId) return null;
  try {
    return localStorage.getItem(key(evolutionSessionId));
  } catch (_) {
    return null;
  }
};

export const forgetEvolutionChat = (evolutionSessionId) => {
  if (!evolutionSessionId) return;
  try {
    localStorage.removeItem(key(evolutionSessionId));
  } catch (_) {
    /* nothing to clean up */
  }
};
